import TicketPrinting from './ticket_printing.vue'

export default {
    path: 'ticketPrinting',
    component: TicketPrinting
}
